export const BRANDING = {
  companyName: "شرکت تجارتی توکل نورزی",
  companyNamePs: "شرکت تجارتی توکل نورزی",
  companyNameFa: "شرکت تجارتی توکل نورزی",
  companyNameEn: "Tawakal Noorzai Trading Company",
  appNameEn: "Tawakal Noorzai Inventory System",
  phonePrimary: "0700000371",
  phoneSecondary: "0787700045",
  phoneDisplay: "0700000371 - 0787700045",
  address: "آدرس: سرک کابل قندهار ، ایستګاه فاضل بیګ ، مقابل ټانګ تیل صداقت",
  addressPs: "پته: سرک کابل قندهار ، ایستګاه فاضل بیګ ، مقابل ټانګ تیل صداقت",
  addressFa: "آدرس: سرک کابل قندهار ، ایستګاه فاضل بیګ ، مقابل ټانګ تیل صداقت",
  addressEn: "Address: Kabul-Kandahar Road, Istgah Market, Sarshyana, Oil Export Factory",
  shortAddress: "سرک کابل قندهار ، ایستګاه فاضل بیګ ، مقابل ټانګ تیل صداقت",
  email: "wahidtajzoi737@gmail.com",
  poweredByEn: "Powered by Tawakal Noorzai Trading Company",
};
